import React from 'react';
import { daysLabelSk } from '../utils/dates';
import Reveal from './Reveal';
import './Stats.css';

/**
 * Pás so štatistikou rezervácií – počíta sa automaticky z iCal kalendára.
 * Zobrazí sa, len ak sú v tomto roku nejaké rezervované dni.
 */
export default function Stats({ bookedNights }) {
  if (!bookedNights) return null;

  return (
    <div className="stats" role="note">
      <div className="container">
        <Reveal>
          <p>
            🔥 Túto sezónu je už rezervovaných{' '}
            <strong>{daysLabelSk(bookedNights)}</strong>. Neváhaj s termínom
            príliš dlho.
          </p>
        </Reveal>
      </div>
    </div>
  );
}
